import type { Options } from '@brighterly/lib-core-types/options/interfaces'
import type { OptionsStore } from './interfaces'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

const getCurrentTime = (state: OptionsStore): Options['current_time'] | null => state.options?.current_time || null
const getCurrentMonth = (state: OptionsStore): string | null => {
  const currentTime = getCurrentTime(state)
  return currentTime
    // codestyle-ignore: date-format-enum — month key 'YYYY-MM' — no DateFormat member (decided 2026-10-24)
    ? dayjs(currentTime).format('YYYY-MM')
    : null
}
const getCurrentTimeUtc = (state: OptionsStore): Options['current_time_utc'] | null => state.options?.current_time_utc || null
const getUpsellCampaignDiscount = (state: OptionsStore): Options['upsell_campaign_discount'] => state.options?.upsell_campaign_discount || 0
const getUpsellDiscount = (state: OptionsStore): number => getUpsellCampaignDiscount(state) || state.options?.pricing_discipline_upsell_discount || 0

export const getters = {
  hasData: (state: OptionsStore): boolean => !!state.options,
  getPadDefaultDiscount: (state: OptionsStore): number => state.options?.pad_default_discount || 0,
  getUpsellCampaignDiscount: (state: OptionsStore): Options['upsell_campaign_discount'] => getUpsellCampaignDiscount(state),
  getUpsellDiscount: (state: OptionsStore): number => getUpsellDiscount(state),
  getCurrentTime: (state: OptionsStore): Options['current_time'] | null => getCurrentTime(state),
  getCurrentMonth: (state: OptionsStore): string | null => getCurrentMonth(state),
  isClassroomInCs: (state: OptionsStore): boolean => !!state.options?.classroom_in_cs || false,
  isCurrentTime: (state: OptionsStore): boolean => !!getCurrentTime(state),
  getCurrentTimeUtc: (state: OptionsStore): Options['current_time_utc'] | null => getCurrentTimeUtc(state),
  isShowTutorProfile: (state: OptionsStore): boolean => !!state.options?.tutor_profile_cs || false,
  getStudentAppUrl: (state: OptionsStore): Options['student_app_url'] | null => state.options?.student_app_url || null,
}
